export const CommunicationConstants = [
    {
        ERROR:'ERROR',
        ERRORBD:'ERRORBD',
        ERRORSRV:'ERRORSRV',
        ERRORCLT:'ERRORCLT',
        ERRORNOCONTENT:'ERRORNOCONTENT',
        TIMEOUT: 'TIMEOUT'
    },
    {
        MSGDATANOCONTENT:'Para la búsqueda no hay datos en el sistema.',
        MSGDATAVACIOSRV:'Se obtuvo respuesta vacía del servidor.',
        MSGERRORSRVINTSERVER:'Se produjo un error en el servidor.',
        MSGERRORSRV:'Se produjo un error en la comunicación con el servidor.',
        MSGERRORCLT:'Se produjo un error en el cliente.',
        MSGFORBIDDEN:'El acceso no está permitido para este usuario.',
        MSGTIMEOUT:'El tiempo de espera se agotó',
        MSG404:'El recurso solicitado no fué encontrado'
    },
]
